"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The CreateCustomerCategoryCommand model module.
 * @module model/CreateCustomerCategoryCommand
 * @version 1.1.3-alpha.1
 */
class CreateCustomerCategoryCommand {
  /**
   * Constructs a new <code>CreateCustomerCategoryCommand</code>.
   * @alias module:model/CreateCustomerCategoryCommand
   * @param title {String} 
   */
  constructor(title) {
    CreateCustomerCategoryCommand.initialize(this, title);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, title) {
    obj['title'] = title;
  }

  /**
   * Constructs a <code>CreateCustomerCategoryCommand</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CreateCustomerCategoryCommand} obj Optional instance to populate.
   * @return {module:model/CreateCustomerCategoryCommand} The populated <code>CreateCustomerCategoryCommand</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CreateCustomerCategoryCommand();
      if (data.hasOwnProperty('title')) {
        obj['title'] = _ApiClient.default.convertToType(data['title'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>CreateCustomerCategoryCommand</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CreateCustomerCategoryCommand</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of CreateCustomerCategoryCommand.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
      throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
    }
    return true;
  }
}
CreateCustomerCategoryCommand.RequiredProperties = ["title"];

/**
 * @member {String} title
 */
CreateCustomerCategoryCommand.prototype['title'] = undefined;
var _default = exports.default = CreateCustomerCategoryCommand;